import useGetDetailItem from "@hooks/Webinar/useGetWebinar";
import formMapper from "@mappers/Modules/webinar/WebinarItem.mapper";
import updateItem from "@services/Webinar/updateWebinar";
import Modify from "@shared/FormTemplates/Modify";
import validator from "@validators/Modules/webinar/webinar.validate";
import { ReactElement } from "react";
import ModifyForm from "./ModifyForm";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
